import styled, {css} from 'styled-components';

import {CopyButton} from 'components/ui-kit/PageComponents';
import {breakpoint, buttonReset, colors, font} from 'theme';

import {Tag} from '../../ui-kit/Tags';

export const DataTitle = styled.div`
    color: ${colors.textPrimary};
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 30px;
`;

export const ErrorsWrapper = styled.div`
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    margin-bottom: 20px;
    margin-top: -24px;
`;

export const Error = styled(Tag)`
    padding: 8px 16px;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: ${colors.white};
    background-color: ${colors.danger};
    border-radius: 6px;
    width: auto;
`;

export const AttachmentsWrapper = styled.div`
    margin-top: 24px;
`;

export const AttachmentsTitle = styled.div`
    margin-bottom: 8px;
    color: ${colors.textSecondary};
    font-size: 13px;
    line-height: 14px;
`;

export const AttachmentsList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
`;

export const AttachmentButton = styled.button`
    ${buttonReset};

    display: flex;
    align-items: center;
    gap: 8px;
    max-width: 100%;
    padding: 6px 10px;
    border-radius: 6px;
    color: ${colors.textPrimary};
    background: ${colors.brandLight};
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;

    &:not(:disabled):hover {
        color: ${colors.brandPrimary};
    }

    &:disabled {
        cursor: default;
        opacity: 0.5;
    }
`;

export const AttachmentName = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const InfoList = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
    border: 1px solid #e2e6ea;
    border-radius: 8px;
    background: ${colors.white};
    padding: 0 16px;
`;

export const InfoListRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 16px;
    width: 100%;
    padding: 14px 0;

    &:not(:last-child) {
        border-bottom: 1px solid #f0f2f5;
    }

    @media (max-width: ${breakpoint.phone}) {
        flex-direction: column;
        gap: 4px;
    }
`;

export const InfoListLabel = styled.div`
    flex-shrink: 0;
    width: 220px;
    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;

    @media (max-width: ${breakpoint.phone}) {
        width: 100%;
    }
`;

export const InfoListValueRow = styled.div`
    display: flex;
    flex: 1;
    min-width: 0;
    align-items: center;
    gap: 10px;
`;

export const InfoListValue = styled.div<{italic?: boolean}>`
    color: ${colors.darkGrey};
    font-family: ${font.family.primary};
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    word-break: break-word;

    ${(p) =>
        p.italic &&
        css`
            font-style: italic;
            font-weight: 400;
        `}
`;

export const InlineCopyButton = styled(CopyButton)`
    margin-left: 0;
    padding: 4px;
`;

export const GeneralInfoContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
`;

export const AttachmentsHeading = styled.h2`
    margin: 0;
    color: ${colors.darkGrey};
    font-family: ${font.family.primary};
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.32px;
    text-transform: uppercase;
`;

export const AttachmentsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
    width: 100%;

    @media (min-width: ${breakpoint.tablet}) {
        grid-template-columns: 1fr 1fr;
    }
`;

export const AttachmentCard = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
    padding: 12px 16px;
    border: 1px solid #e2e2e2;
    border-radius: 8px;
    background: ${colors.white};
`;

export const AttachmentFileIcon = styled.span<{background: string}>`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    background-color: ${({background}) => background};
    color: ${colors.white};
    font-size: 10px;
    font-weight: 700;
    line-height: 15px;
    text-transform: uppercase;
`;

export const AttachmentFileMeta = styled.div`
    display: flex;
    min-width: 0;
    flex: 1;
    flex-direction: column;
`;

export const AttachmentFileName = styled.span`
    overflow: hidden;
    color: ${colors.darkGrey};
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const AttachmentDownloadButton = styled.button`
    ${buttonReset};

    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 6px;

    &:not(:disabled):hover {
        background-color: ${colors.brandLight};
    }

    &:disabled {
        cursor: default;
        opacity: 0.5;
    }
`;
